import React from 'react'
import './PostgraduatePathway.css';
function PostgraduatePathways({programData}) {
   return (
      <>
         <div className="section-container" >
            <div className="section-title-cont">
               <hr className="section-title-line" />
               <h3 className="section-title">Postgraduate Pathways</h3>
            </div>
            <div className="card-holder">
               <table style={{ width: "100%" }} class="theme_table">
                  <thead>
                     <tr>
                        <th>Program</th>
                        <th>Best Countries</th>
                        <th>Hook</th>
                     </tr>
                  </thead>
                  <tbody>
                     {programData.map((program, index) => (
                        <tr key={index}>
                           <td><strong>{program.program}</strong></td>
                           <td>{program.bestCountries.join(",")}</td>
                           <td>{program.hook}</td>
                        </tr>
                     ))}
                    
                  </tbody>
               </table>

            </div>

         </div>
      </>
   )
}

export default PostgraduatePathways
